import * as environmentService from '../utils/general/environmentService';
import $ from "jquery";
import _, { includes } from 'lodash';

const _HTML_RENDITION: any = window.HTML_RENDITION;

export interface IServiceConfig {
    method?: string;                            // Ajax method, default value is GET. If uses POST, need override
    contentType?: string;                       // Ajax contentType, using to send to sever the data format. value has been set in axios-services, is application/json
    serve_for_expiry?: boolean;                 // Set for rendition timed expiry link. If the value is true, means it will using EXPIRY_URL_BASE_TOKEN value in the request url.
    particular_expiry_url_token?: string;       // If the request url for expiry link isn't EXPIRY_URL_BASE_TOKEN, will use this value to replace
    expiry_url_token?: string;                  // The common expiry url token. When the request is expiry request, will use expiry_url_token
    abort_previous_requests: boolean;           // Abort previous requests. Find logic in axios-services.tsx
    url_parameter?: Array<string>;              // Url parameters
    url_tokens: Array<string>;                  // The url pattern
    showmask: boolean;                          // If show mask when send this request
    headers?: object;                           // custom config headers
    cleanupInvalidParameter?: boolean;          // remove extra & in query parameter
}

interface IServiceConfigKey {
    [key: string]: any;
}

const FORWARD_SLASH = '/';
const QUESTION_MARK = '?';
const AND_MARK = '&';

// Tokens are different url patterns used in different scenarios.
const URL_BASE_TOKEN = _HTML_RENDITION.initialData.mode == 'preview_mode' ? 'rendition/eppublic/uiservices/preview' : 'rendition/eppublic/uiservices';
const CVR_BASE_SERVICE = 'cvrservices/eppublic';
let URL_AKPROTECTED_TOKEN = ''; // 'rendition/akprotected/documents/output';
if (_HTML_RENDITION.initialData.protectedPath){
    URL_AKPROTECTED_TOKEN = _HTML_RENDITION.initialData.protectedPath.substr(1).slice(0, -1);
}
const URL_PROTECTED_TOKEN = _HTML_RENDITION.initialData.mode == 'preview_mode' ? 'rendition/eppublic/protected/service/preview' : 'rendition/eppublic/protected/service';
const URL_URL_AKPUBLIC_TOKEN = 'rendition/eppublic/akpublic/documents/' + (_HTML_RENDITION.initialData.isStaticHtml ? "1_003" : _HTML_RENDITION.initialData.doc_app_version);

const EXPIRY_URL_BASE_TOKEN = 'rendition/eppublic/service';
let EXPIRY_URL_AKPUBLIC_TOKEN = ''; // 'rendition/eppublic/akpublic/documents/output';
if (_HTML_RENDITION.initialData.unProtectedPath){
    EXPIRY_URL_AKPUBLIC_TOKEN = _HTML_RENDITION.initialData.unProtectedPath.substr(1).slice(0, -1);
}

const timeStamp = (window.HTML_RENDITION.initialData.isNewOutput) ? _HTML_RENDITION.initialData.extractionCompletionMillisec : _HTML_RENDITION.initialData.buildTimeStamp;
// If this doc is opened by expired link
const isTimedLinkAvailable = _HTML_RENDITION.initialData.isTimedLinkAvailable || false;

// Expiry link has linkId, using calculate the expiry date
const getLinkId = () => {
    const linkId = ($ && $.trim) ? $.trim(_HTML_RENDITION.linkId) : _HTML_RENDITION.linkId;
    if (isTimedLinkAvailable === true && linkId && linkId != ''){
        return linkId;
    }
    return '';
};

const serviceConfig: IServiceConfigKey = {
    EXPIRY_URL_BASE_TOKEN,
    EXPIRY_URL_AKPUBLIC_TOKEN,
    GET_CONTENT_TYPE: (serviceDetail: IServiceConfig) => {
        return serviceDetail.contentType;
    },
    GET_METHOD: (serviceDetail: IServiceConfig) => {
        return serviceDetail.method ? serviceDetail.method : 'GET';
    },
    // used to calculate a request url
    GET_URL: (serviceDetail: IServiceConfig) => {
        if (((isTimedLinkAvailable === true && getLinkId()) || _HTML_RENDITION.initialData.isPublic) && serviceDetail.serve_for_expiry){
            if (serviceDetail.particular_expiry_url_token){
                serviceDetail.url_tokens = serviceConfig[serviceDetail.particular_expiry_url_token].url_tokens;
            } else {
                const urlToCompare = serviceDetail.url_tokens[1]?.split('/')[0];
               if (urlToCompare !== 'copy-url') {
                 serviceDetail.url_tokens[0] =
                   serviceDetail.expiry_url_token == "EXPIRY_URL_BASE_TOKEN"
                     ? EXPIRY_URL_BASE_TOKEN
                     : EXPIRY_URL_AKPUBLIC_TOKEN;
               }
            }

            if (serviceDetail.url_parameter){
                serviceDetail.url_parameter.push(`linkId=${getLinkId()}`);
            } else {
                serviceDetail.url_parameter = [`linkId=${getLinkId()}`];
            }
        }
        let url = serviceDetail.url_tokens.join(FORWARD_SLASH);
        if (serviceDetail.url_tokens[0].charAt(0) !== '.' && serviceDetail.url_tokens[0].charAt(0)) {
            url = FORWARD_SLASH + url;
        }
        if (serviceDetail.url_parameter && serviceDetail.url_parameter.length > 0) {
            if (window.HTML_RENDITION.initialData.isPublic || serviceDetail.cleanupInvalidParameter){
                let url_parameter = _.filter(serviceDetail.url_parameter, (kv) => {
                    if (!kv){
                        return false;
                    }
                    const arr = _.split(kv, '=');
                    if (_.size(arr) != 2){
                        return false;
                    }
                    if (arr[1] == 'undefined' || arr[1] == 'null'){
                        return false;
                    }
                    return true;
                });

                if (serviceDetail.url_tokens[1] === "copy-url/generate") {
                  url_parameter = serviceDetail.url_parameter;
                }

                url = url + QUESTION_MARK + url_parameter.join(AND_MARK);
            } else {
                const para = serviceDetail.url_parameter.join(AND_MARK);
                url = url + QUESTION_MARK + para;
            }
        }
        return url;
    },
    // /rendition/eppublic/uiservices/log => used to push log to backend log
    PUSH_LOG_TO_BACKEND: {
        method: 'POST',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'log',
        ],
    },
    // Static json data
    // unProtectedPath: /rendition/eppublic/akpublic/documents/output/ => when use expiry link
    // Example: /rendition/eppublic/akpublic/documents/output/30031409/body_section_1.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5x_A1nEydhlo&parent_doc_id=null&doc_id=30031409&rendition_doc_id=30031409&ts=1630396293984&version=3
    // ProtectedPath: /rendition/akprotected/documents/output/ => get from initialData
    // Example: /rendition/akprotected/documents/output/30031409/body_section_1.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5x_A1nEydhlo&parent_doc_id=null&doc_id=30031409&rendition_doc_id=30031409&ts=1630396293984&version=3
    GET_BODY_JSON_DATA_ONE_BY_ONE: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_AKPUBLIC_TOKEN',
        abort_previous_requests: true,
        showmask: true,
        url_tokens: [
            URL_AKPROTECTED_TOKEN,
            _HTML_RENDITION.doc_id,
        ],
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Static json data, HTML editor body json
    // unProtectedPath: /rendition/eppublic/akpublic/documents/output/ => when use expiry link
    // Example: /rendition/eppublic/akpublic/documents/output/30030853/body_section.json?id=undefined&parent_doc_id=30021386&doc_id=30030853&rendition_doc_id=30030853&ts=1629713753548&version=1
    // ProtectedPath: /rendition/akprotected/documents/output/ => get from initialData
    // Example: /rendition/akprotected/documents/output/30030853/body_section.json?id=undefined&parent_doc_id=30021386&doc_id=30030853&rendition_doc_id=30030853&ts=1629713753548&version=1
    GET_BODY_JSON_DATA: {
        abort_previous_requests: true,
        showmask: true,
        url_tokens: (environmentService.getJsonPath('body_section').split('?'))[0].split('/').filter((str:string) => str != ''),
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Static json data
    // unProtectedPath: /rendition/eppublic/akpublic/documents/output/ => when use expiry link
    // Example: /rendition/eppublic/akpublic/documents/output/30031409/header_section_noesi.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5x_A1nEydhlo&parent_doc_id=null&doc_id=30031409&rendition_doc_id=30031409&ts=1630396293984&version=3
    // ProtectedPath: /rendition/akprotected/documents/output/ => get from initialData
    // Example: /rendition/akprotected/documents/output/30031409/header_section_noesi.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5x_A1nEydhlo&parent_doc_id=null&doc_id=30031409&rendition_doc_id=30031409&ts=1630396293984&version=3
    GET_HEADER_JSON_DATA: {
        abort_previous_requests: false,
        showmask: true,
        url_tokens: (environmentService.getJsonPath(_HTML_RENDITION.initialData.header_file_name).split('?'))[0].split('/').filter((str:string) => str != ''),
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Static json data. Only word has footer json, html editor has no footer json.
    // unProtectedPath: /rendition/eppublic/akpublic/documents/output/ => when use expiry link
    // Example: /rendition/eppublic/akpublic/documents/output/30031409/footer_section.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5x_A1nEydhlo&parent_doc_id=null&doc_id=30031409&rendition_doc_id=30031409&ts=1630396293984&version=3
    // ProtectedPath: /rendition/akprotected/documents/output/ => get from initialData
    // Example: /rendition/akprotected/documents/output/30031409/footer_section.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5x_A1nEydhlo&parent_doc_id=null&doc_id=30031409&rendition_doc_id=30031409&ts=1630396293984&version=3
    GET_FOOTER_JSON_DATA: {
        abort_previous_requests: false,
        showmask: true,
        url_tokens: (environmentService.getJsonPath('footer_section').split('?'))[0].split('/').filter((str:string) => str != ''),
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Example: /rendition/akprotected/documents/output/30031211/economic_calendar.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5qqE0O2oIjvs&parent_doc_id=null&doc_id=30031211&rendition_doc_id=30031211&ts=1630053004651&version=2
    GET_ECONOMIC_CALENDAR_JSON_DATA: {
        abort_previous_requests: false,
        showmask: false,
        url_tokens: (environmentService.getJsonPath('economic_calendar').split('?'))[0].split('/').filter((str:string) => str != ''),
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Example: /rendition/akprotected/documents/output/30031211/corporate_calendar.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5qqE0O2oIjvs&parent_doc_id=null&doc_id=30031211&rendition_doc_id=30031211&ts=1630053004651&version=2
    GET_EVENT_CALENDAR_JSON_DATA: {
        abort_previous_requests: false,
        showmask: false,
        url_tokens: (environmentService.getJsonPath('corporate_calendar').split('?'))[0].split('/').filter((str:string) => str != ''),
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Static HTML data. Only PPT/Landscape has HTML file as content, which extracted from PDF.
    // unProtectedPath: /rendition/eppublic/akpublic/documents/output/ => when use expiry link
    // Example: /rendition/eppublic/akpublic/documents/output/30031390/pdf2html/1.html?doc_id=30031390
    // ProtectedPath: /rendition/akprotected/documents/output/ => get from initialData
    // Example: /rendition/akprotected/documents/output/30031390/pdf2html/1.html?doc_id=30031390
    GET_PRESENTATION_HTML_DATA: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_AKPUBLIC_TOKEN',
        abort_previous_requests: true,
        showmask: true,
        url_tokens: [
            URL_AKPROTECTED_TOKEN,
            _HTML_RENDITION.doc_id,
            'placeholder'
        ],
        url_parameter: [
            'doc_id=' + _HTML_RENDITION.doc_id,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/flip_version
    // Public: /rendition/eppublic/service/flip_version
    GET_FLIP_VERISON_DOC: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'flip_version',
        ],
        url_parameter: [
            'doc_id=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Protected: /rendition/eppublic/uiservices/flip_version
    // Public: /rendition/eppublic/service/flip_version
    GET_ORIGIN_FLIP_VERISON_DOC: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'flip_version',
        ],
        url_parameter: [
            'doc_id=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Protected: /rendition/eppublic/uiservices/cv_tab_menu
    // Public: /rendition/eppublic/service/cv_tab_menu
    GET_CV_MENU: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'cv_tab_menu',
            /// ?&=4452574&=1554690807209
        ],
        url_parameter: [
            // TBD
            'asset=' + 'Equities',
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            // ts
        ],
    },
    // Static json data, only for MCN
    // unProtectedPath: /rendition/eppublic/akpublic/documents/output/ => when use expiry link
    // Example: /rendition/eppublic/akpublic/documents/output/30028517/section.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5Wkurs1GrYDc&parent_doc_id=null&doc_id=30028517&rendition_doc_id=30028517&ts=1626204953250&version=3
    // ProtectedPath: /rendition/akprotected/documents/output/ => get from initialData
    // Example: /rendition/akprotected/documents/output/30028517/section.json?id=RwgCUJn1oscxDjKR_hI7jUpsIm2cQZy5Wkurs1GrYDc&parent_doc_id=null&doc_id=30028517&rendition_doc_id=30028517&ts=1626204953250&version=3
    GET_SECTION_DATA: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_AKPUBLIC_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_AKPROTECTED_TOKEN,
            _HTML_RENDITION.doc_id,
            'section.json',
        ],
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
            _HTML_RENDITION.initialData.isStaticHtmlExport ? 'show_html_only=true&internal_use_only=true' : '',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') ? ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()) : '',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/generate_copyURL
    // Public: /rendition/eppublic/service/generate_copyURL
    // https://uat.citivelocity.com/cvrservices/eppublic/copy-url/cv?url=
    GET_CVR_URL: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        method: 'POST',
        url_tokens: [
            CVR_BASE_SERVICE,
            'copy-url/cv',
        ]
    },
    GET_COPY_URL: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'generate_copyURL',
        ]
    },
    GET_PUBLIC_COPY_URL: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'generate_copyURL',
        ]
    },
    // Example: /cvrservices/eppublic/copy-url/generate
    GET_CVR_COPY_URL: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            CVR_BASE_SERVICE,
            'copy-url/generate',
        ]
    },

    GET_CATALYST_WATCH_BY_COMPANY_CODE: {
        url_tokens: [
             CVR_BASE_SERVICE,
            'rdhV3DataService',
        ]
    },

    GET_ANALYST_DIRECTORY_DATA: {
        method: 'GET',        
        url_tokens: [
             CVR_BASE_SERVICE,
            'getAnalystDirectoryData',
        ]
    },
    // Protected: /rendition/eppublic/uiservices/campaigns
    // Public: /rendition/eppublic/service/campaigns
    GET_CAMPAIGNS: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'campaigns',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/events
    // Public: /rendition/eppublic/service/events
    GET_EVENTS: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        method: 'POST',
        url_tokens: [
            URL_BASE_TOKEN,
            'events',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/stylesFactors
    // Public: /rendition/eppublic/service/stylesFactors
    GET_STYLE_FACTORS: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'stylesFactors',
        ],
        url_parameter: [
            'docId=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Protected: /rendition/eppublic/uiservices/crmuserdetails
    // Public: /rendition/eppublic/service/crmuserdetails
    GET_CRM_USER_DETAILS: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: true,
        url_tokens: [
            URL_BASE_TOKEN,
            'crmuserdetails',
        ],
        url_parameter: [
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Recommended Example: /rendition/eppublic/uiservices/doc_classification_service?count=3&serviceType=rec&rendition_doc_id=30028517&requestId=HTML_RENDITION.requestid
    // Popular Example: /rendition/eppublic/uiservices/doc_classification_service?count=3&serviceType=pop&rendition_doc_id=30028517&requestId=HTML_RENDITION.requestid
    GET_STACKS: {
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'doc_classification_service',
        ],
    },

    // Recommended Example: /rendition/eppublic/uiservices/doc_classification_service?count=3&serviceType=rec&rendition_doc_id=30028517&requestId=HTML_RENDITION.requestid
    // Popular Example: /rendition/eppublic/uiservices/doc_classification_service?count=3&serviceType=pop&rendition_doc_id=30028517&requestId=HTML_RENDITION.requestid
    GET_RELATED_RESEARCH_STACKS: {
        abort_previous_requests: false,
        showmask: false,
        headers: {
            Accept: 'application/json',
            callerId: 'RENDITION',
        },
        url_tokens: [
            "cvr/publicationqueryws/eppublic/V1/publications.json"
        ],
        url_parameter: [
            'docIds=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Protected: /rendition/eppublic/uiservices/reportingCalendar
    // Public: /rendition/eppublic/service/reportingCalendar
    // Post Data example: {"start":1,"count":50,"time":1630898705363,"selections":{"region":"Global","sort":"asc","productType":"Essentials","country":"All Countries"}}
    GET_REPORTING_CALENDAR: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        method: 'POST',
        url_tokens: [
            URL_BASE_TOKEN,
            'reportingCalendar',
        ],
    },
    // Example: /rendition/akprotected/documents/output/30028517/catalystWatch.json?encodedDynamic=undefined&encodedStatic=undefined&doc_id=30028517
    GET_CATALYST_WATCH: 'catalystWatch',
    // Example: /rendition/eppublic/uiservices/mail?brandingSeries=Deep%20Dive&rendition_doc_id=30028517&type=rts
    GET_MAIL: {
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'mail',
        ],
    },
    // Example: /rendition/eppublic/uiservices/mail?rendition_doc_id=30028517&type=rcm
    POST_MAIL: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        method: 'POST',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'mail',
        ],
    },
    GET_FP_FIGURE_GALLERY: 'fp_figure_gallery',
    // Example: /rendition/akprotected/documents/output/30031518/figure_gallery.json?encodedDynamic=undefined&encodedStatic=undefined&doc_id=30031518
    GET_FIGURE_GALLERY: 'figure_gallery',
    // Protected: /rendition/eppublic/uiservices/forecast
    // Public: /rendition/eppublic/service/forecast
    GET_FORECAST: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'forecast',
        ],
    },
    // Protected: => /rendition/eppublic/protected/service/getFinsum
    // Public: => EXPIRY_GET_FINSUM
    GET_FINSUM: {
        serve_for_expiry: true,
        particular_expiry_url_token: 'EXPIRY_GET_FINSUM',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_PROTECTED_TOKEN,
            'getFinsum',
        ],
    },
    // Example: /rendition/akprotected/documents/output/30011770/finsum.json?encodedDynamic=undefined&encodedStatic=undefined&doc_id=30011770
    GET_FINSUM_JSON: {
        abort_previous_requests: false,
        showmask: false,
        url_tokens: (environmentService.getJsonPath('finsum').split('?'))[0].split('/').filter((str:string) => str != ''),
        url_parameter: (environmentService.getJsonPath('finsum').split('?'))[1].split('&').filter((str:string) => str != '')
    },
    // Example: /rendition/eppublic/uiservices/point_documents_by_region?documentId=30036667&region=GLO&position=0&periodicalId=&parentDocData=cGFyZW50X2RvY19pZD0zMDAzNjY2NyZjaGFubmVsPWNpdGl2ZWxvY2l0eSZzdWItY2hhbm5lbD13ZWImcGxhdGZvcm09Nzg
    GET_REGION_BAR_DATA: {
        abort_previous_requests: false,
        showmask: true,
        url_tokens: [
            URL_BASE_TOKEN,
            'point_documents_by_region',
        ],
    },
    /**
     * @example: /cvrservices/eppublic/citisbest/flagshipPeriodicals?documentId=6459880&position=2&id=101024
     */
    GET_FLAGSHIP_PERIODICAL_DATA: {
        abort_previous_requests: false,
        showmask: true,
        url_tokens: [
            'cvrservices',
            'eppublic',
            'citisbest',
            'flagshipPeriodicals',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/pricechart
    // Public: /rendition/eppublic/service/pricechart
    GET_PRICECHART: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'pricechart',
        ],
    },
    // Protected: /rendition/eppublic/protected/service/getReportsToRevisit
    // Public: => EXPIRY_GET_REPORTS_TO_REVISIT
    GET_REPORTS_TO_REVISIT: {
        serve_for_expiry: true,
        particular_expiry_url_token: 'EXPIRY_GET_REPORTS_TO_REVISIT',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_PROTECTED_TOKEN,
            'getReportsToRevisit',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/themes
    // Public: /rendition/eppublic/service/themes
    GET_THEMES: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'themes',
        ],
    },
    // example: /cvrservices/eppublic/getEsgData?cache=true&sector=diversifiedbanks&classification=SB
    // Support expiry but needn't change the url, because the data is under eppublic
    GET_ESG: {
        serve_for_expiry: false,
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            'cvrservices/eppublic/getEsgData'
        ],
    },
    // example: /cvrservices/eppublic/companyCoverageAndDerivedFields?ticker=CMTL
    // Support expiry but needn't change the url, because the data is under eppublic
    GET_COMPANY_INFO: {
        serve_for_expiry: false,
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            'cvrservices/eppublic/companyCoverageAndDerivedFields'
        ],
    },
    // example: /cvrservices/eppublic/rdhDataService?uri=GET_RESTRICTION_DETAILS&companyCode=0038.CN%2C2338.CN%2CCAP.CL%2C601333.CN%2C2357.CN%2C601766.CN
    GET_RESTRICTION_DETAILS: {
        serve_for_expiry: false,
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            'cvrservices/eppublic/companyCoverageAndDerivedFields'
        ],
    },
    // Protected: /rendition/eppublic/uiservices/getCVMData
    // Public: /rendition/eppublic/service/getCVMData
    GET_CV_MACRO_TOOLS: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'getCVMData',
        ],
        url_parameter: [
            'docId=' + _HTML_RENDITION.doc_id,
            'oboAnalystSoeid=' + window.HTML_RENDITION.initialData.oboAnalystSoeid,
            'product=' + window.HTML_RENDITION.initialData.productCode,
        ],
    },
    // Example: /rendition/eppublic/protected/service/updatePoll?rendition_doc_id=30028586&choiceId=undefined&pollId=1167
    GET_INSTANT_POLL_DATA: {
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_PROTECTED_TOKEN,
            'updatePoll',
        ],
        url_parameter: [
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Example: /rendition/eppublic/uiservices/doc_classification_service?rendition_doc_id=30028517&serviceType=rel&related_doc_ids=30028231,30028499,30028133
    GET_RELATED_REPORT_DATA: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'doc_classification_service',
        ],
        url_parameter: [
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'serviceType=rel',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/getAnalystInfo
    // Public: /rendition/eppublic/service/getAnalystInfo
    GET_ANALYST_INFO: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'getAnalystInfo',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/getBullBearData
    // Public: /rendition/eppublic/service/getBullBearData
    GET_BULL_BEAR_DATA: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'getBullBearData',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/print
    // Public: /rendition/eppublic/service/print
    GET_PRINT: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'print',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/globalMarketData
    // Public: /rendition/eppublic/service/globalMarketData
    GET_GLOBAL_MARKET_DATA: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'globalMarketData',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/globalMarketData
    // Public: /rendition/eppublic/service/globalMarketData
    GET_ECONOMIC_CALENDAR_DATA: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'globalMarketData',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/keyDataChanges
    // Public: /rendition/eppublic/service/keyDataChanges
    GET_KEY_DATA_CHANGE: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'keyDataChanges',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/mustReadSection
    // Public: /rendition/eppublic/service/mustReadSection
    GET_MUST_READ_SECTION: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'mustReadSection',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/point_documents_by_region
    // Public: /rendition/eppublic/service/point_documents_by_region
    GET_POINT_DOCUMENT_BY_REGION: {
        serve_for_expiry: true,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'point_documents_by_region',
        ],
    },
    // Protected: /rendition/eppublic/uiservices/focuslist
    // Public: => EXPIRY_GET_FOCUS_LIST
    GET_FOCUS_LIST: {
        serve_for_expiry: true,
        particular_expiry_url_token: 'EXPIRY_GET_FOCUS_LIST',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: ((window.HTML_RENDITION.initialData.productType === "point") ?
            [URL_BASE_TOKEN, 'focuslist'] : (environmentService.getJsonPath('focuslist').split('?'))[0].split('/').filter((str:string) => str != '')),
        url_parameter: [
            'id=' + _HTML_RENDITION.initialData.id,
            'parent_doc_id=' + _HTML_RENDITION.initialData.parent_doc_id,
            'doc_id=' + _HTML_RENDITION.doc_id,
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
        ],
    },
    // Protected: /rendition/eppublic/uiservices/video_related_reports
    // Public: /rendition/eppublic/service/video_related_reports
    GET_RELATED_PUBLICATIONS: {
        serve_for_expiry: true,
        abort_previous_requests: false,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        showmask: false,
        url_tokens: [
            URL_BASE_TOKEN,
            'video_related_reports',
        ],
        url_parameter: [
            'docId=' + _HTML_RENDITION.doc_id,
        ],
    },
    // Example: /rendition/eppublic/akpublic/documents/1_003/json/Clickthru.json?rendition_doc_id=30028586&ts=1626329267825&version=2
    GET_CLICK_THRU_DATA: {
        url_tokens: [
            URL_URL_AKPUBLIC_TOKEN,
            'json',
            'Clickthru.json',
        ],
        url_parameter: [
            'rendition_doc_id=' + _HTML_RENDITION.doc_id,
            'ts=' + timeStamp,
            'version=' + _HTML_RENDITION.initialData.version,
        ]
    },
    // /rendition/eppublic/service/reportError
    POST_ERROR_ALERT: {
        method: 'POST',
        abort_previous_requests: false,
        showmask: false,
        url_tokens: [
            EXPIRY_URL_BASE_TOKEN,
            'reportError',
        ],
    },

    GET_SESSION_CONTEXT_DATA: {
        url_tokens: [
            'cvrservices',
            'eppublic',
            'getSessionContext',
        ],
    },

    GET_PLATFORM_ID_DATA: {
        url_tokens: [
            'cvrservices',
            'eppublic',
            'getConfigProperty',
        ],
        url_parameter: [
            'configProperty=readMorePlatform',
        ]
    },

    GET_EXCLUDE_COPY_FIGURE_PLATFORM_ID_DATA: {
        url_tokens: [
            'cvrservices',
            'eppublic',
            'getConfigProperty',
        ],
        url_parameter: [
            'configProperty=excludeCopyFigurePlatforms',
        ]
    },

    /* Add Expiry Link Using URLs */
    // Protected: => GET_REPORTS_TO_REVISIT
    // Public: /rendition/eppublic/service/getReportsToRevisitPublic
    EXPIRY_GET_REPORTS_TO_REVISIT: {
        url_tokens: [
            'rendition',
            'eppublic',
            'service',
            'getReportsToRevisitPublic',
        ],
    },
    // Protected: => GET_FINSUM
    // Public: /rendition/eppublic/service/focuslist
    EXPIRY_GET_FINSUM: {
        url_tokens: [
            'rendition',
            'eppublic',
            'service',
            'getFinsumPublic',
        ],
    },
    // Protected: => GET_FOCUS_LIST
    // Public: => EXPIRY_GET_FOCUS_LIST
    EXPIRY_GET_FOCUS_LIST: {
        url_tokens: [
            'rendition',
            'eppublic',
            'service',
            'focuslist',
        ],
    },
    // /rendition/eppublic/service/openTimedVideo
    EXPIRY_GET_VIDEO_URL: {
        url_tokens: [
            'rendition',
            'eppublic',
            'service',
            'openTimedVideo',
        ],
    },
    // /cvr/publicationqueryws/eppublic/V1/publications.json
    GET_OFFCUFF_PUBLICATIONS: {
        method: 'GET',
        showmask: true,
        url_tokens: [
             'rendition',
             'uiws',
             'eppublic',
             'V1',
             'documentQuery.json',
        ]
    },
    // http://domain/rendition/uiws/eppublic/V1/single-author.json?analystid=analystid
    GET_SINGLE_AUTHOR_TOPICS: {
        method: 'GET',
        url_tokens: [
            'rendition',
            'uiws',
            'eppublic',
            'V1',
            'single-author.json'
        ],
    },
    // http://domain/rendition/uiws/eppublic/V1/all-author.json?periodicalid=periodicalid
    GET_ALL_AUTHORS_TOPICS: {
        method: 'GET',
        url_tokens: [
            'rendition',
            'uiws',
            'eppublic',
            'V1',
            'all-authors.json',
        ],
    },
    // rendition/eppublic/uiservices/open_document
    GET_POST_DOC: {
        method: 'GET',
        url_tokens: [
            'rendition',
            'eppublic',
            'uiservices',
            'open_document',
        ],
    },
    // rendition/eppublic/documentService/
    GET_DEFAULT_POST_DOC: {
        method: 'GET',
        url_tokens: [
            'rendition',
            'eppublic',
            'documentService',
            window.HTML_RENDITION.initialData.encodedDynamic,
            window.HTML_RENDITION.initialData.encodedStatic
        ],
    },
    // http://domain/rendition/uiws/eppublic/V1/multimedia.json
    GET_MULTIMEDIA: {
        method: 'GET',
        url_tokens: [
            'rendition',
            'uiws',
            'eppublic',
            'V1',
            'multimedia.json',
        ],
    },
    // http://domain/rendition/uiws/eppublic/public/V1/multimedia.json
    GET_PUBLIC_MULTIMEDIA: {
        method: 'GET',
        url_tokens: [
            'rendition',
            'uiws',
            'eppublic',
            'public',
            'V1',
            'multimedia.json',
        ],
    },
    getBookMeetingEntitlement:{
        serve_for_expiry: true,
        abort_previous_requests: false,
        expiry_url_token: 'EXPIRY_URL_BASE_TOKEN',
        showmask: false,
        cleanupInvalidParameter: true,
        url_tokens: [
            URL_BASE_TOKEN,
            'getBookMeetingEntitlement',
        ],
        url_parameter: [
            (_HTML_RENDITION.initialData?.subMode == 'lite_view' || _HTML_RENDITION.initialData?.html_light_rendition) && 'lite_view=true',
            _HTML_RENDITION.initialData.isStaticHtmlExport && 'show_html_only=true&internal_use_only=true',
            (window.HTML_RENDITION.initialData.isNewOutput && _HTML_RENDITION.initialData.mode == 'static_view') && ('static_view=true&interal_use_only=true&productCode=' + _HTML_RENDITION.initialData.productType.toUpperCase()),
        ],
    },
    // /cvr/publicationqueryws/eppublic/V1/publications.json?platformId=
    GET_FILE_URL_PATH: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          callerId: 'RDE',
        },
        url_tokens: [
            'rendition',
            'urlfactoryws',
            'eppublic',
            'V1',
            'URL.json',
        ],
    },

    GET_RENDITION_LINK: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          callerId: 'RENDITIONBE',
        },
        url_tokens: [
            'rendition',
            'urlfactoryws',
            'eppublic',
            'V1',
            'URL.json',
        ],
        url_parameter: [],
    },

    // /rendition/eppublic/uiservices/mail?type=rcm
    GET_SEND_EMAIL_DATA: {
        method: 'POST',
        url_parameter: [
            'type=rcm'
        ],
        url_tokens: [
            URL_BASE_TOKEN,
            'mail',
        ],
    },
    // cvr/publicationqueryws/eppublic/V1/publications.json?platformId=78
    GET_ANALYST_MODEL: {
        method: 'POST',
        headers: {callerId: 'CVR'},
        url_tokens: [
            'cvr',
            'publicationqueryws',
            'eppublic',
            'V1',
            'publications.json',
        ],
    },
    // /cvrservices/eppublic/companyCoverage?ticker=
    GET_COMPANY_COVERAGE_BY_TICKER: {
        method: 'GET',
        url_tokens: [
            CVR_BASE_SERVICE,
            'companyCoverage',
        ],
    },
    // /research/eppublic/service/getUserEntitlements
    GET_USER_ENTITLEMENTS: {
        method: 'GET',
        url_tokens: [
            'research',
            'eppublic',
            'service',
            'getUserEntitlements',
        ],
    },
    // /cvrservices/eppublic/rdhDataService?companyCode=8801.JP&uri=GET_EXPECTED_PERFORMANCE
    GET_EXPECTED_PERFORMANCE: {
        method: 'GET',
        url_tokens: [
            CVR_BASE_SERVICE,
            'rdhDataService',
        ],
    },

    POST_SUBSCRIBE_AUTHOR_BY_SOEID: {
        method: 'POST',
        url_tokens: [
            'subscriptions',
            'center',
            'icg',
            'subscribeAuthor'
        ],
        url_parameter: [],
        headers: {},
    },

    GET_ALL_CAMPAIGNS_DATA: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            callerId: 'CAMPAIGN_ADMIN',
            "x-citiportal-loginid": 'vs75899', //remove this while pushing
        },
        url_tokens: [
            'rendition',
            'campaignws',
            'eppublic',
            'V1',
            'admin',
            'campaigns.json',
        ]
    }
};



export default serviceConfig;
